import { Button, Col, Divider, Flex, Form, Input, InputNumber, notification, Row, Spin } from "antd";
import { ReactElement, useEffect } from "react";
import { useBuscar, useSalvar } from "../../../../../Services/Financeiro/Faturamento/ServicoServices";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";
import ValorServicoFormBasic from "../Imposto/Configuracao/Valor/ValorServico/ValorServicoFormBasic";
import { EnumGrupoTributario } from "../../../../../Models/Financeiro/Faturamento/Imposto/GrupoTributario";
import RegimeTributario from "../../../../../Models/Financeiro/Faturamento/Imposto/RegimeTributario";
import ValorServico from "../../../../../Models/Financeiro/Faturamento/Imposto/Configuracao/Valor/ValorServico";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { PermissoesKey } from "../../../../../Constants/Permissoes";
import EmpresaFaturamento from "../../../../../Models/Financeiro/Faturamento/EmpresaFaturamento";
import RegimeTributarioSelect from "../Imposto/RegimeTributario/RegimeTributarioSelect";
import { useEmpresaFaturamentoBuscar, useEmpresaFaturamentoSalvar } from "../../../../../Services/Financeiro/Faturamento/EmpresaFaturamentoServices";

interface IEmpresaFaturamentoFormCadastroProps {
    codPessoa:number,
    buttoCencelar?: ReactElement,
    onCancelar?: (evento: React.MouseEvent<HTMLElement, MouseEvent>) => void,
    onSalvarSucesso?: () => void
}
type FormType = EmpresaFaturamento;
export default function EmpresaFaturamentoForm({
    buttoCencelar,
    onCancelar,
    onSalvarSucesso,
    codPessoa
}: IEmpresaFaturamentoFormCadastroProps) {
    const isAlteracao = codPessoa !== undefined && codPessoa !== null && codPessoa > 0;
    const [formulario] = Form.useForm<FormType>();
    const regimeTributario = Form.useWatch<RegimeTributario>("regimeTributario", formulario);

    // const {
    //     data : dataRegimeTributario,
    //     isPending : isPendingRegimeTributario,
    //     isSuccess : isSuccessRegimeTributario,
    //     isError : isErrorRegimeTributario
    // } = useListar({
    //     ativo : true,
    //     enabled : isAlteracao
    // });

    const {
        isSuccess,
        isError,
        isPending : isPedingBuscarServico,
        data : empresaFaturamentoAtual
    } = useEmpresaFaturamentoBuscar({
        codPessoa,
        enabled : isAlteracao //&& isSuccessRegimeTributario
    });

    const {
        mutate,
        isPending
    } = useEmpresaFaturamentoSalvar({
        onSuccess: onSalvarSucesso ?? (() => {
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Configuração de faturamento salva com sucesso."
            });
        })
    });

    useEffect(() => {
        if (isSuccess && empresaFaturamentoAtual)
            formulario.setFieldsValue((empresaFaturamentoAtual ?? {}) as any);
    }, [isSuccess]);
    // useEffect(() => {
    //     if (isError || (isSuccess && servicoSalvo === null)) {
    //         onCancelar?.({} as any);
    //         notification.info({
    //             ...PropriedadesDeNotificacao["Aviso"],
    //             message : "Não foi possível encontrar a empresa que deseja alterar."
    //         });
    //     }
    // }, [isError, isSuccess, servicoSalvo]);

    // useEffect(() => {
    //     if (isSuccess && servicoSalvo !== null) {
    //         servicoSalvo.regimesTributarios = Utilitario.groupBy(
    //                 servicoSalvo.valoresImpostos.map(m => m.valor?.codRegimeTributario),
    //                 (codRegimeTributario) => codRegimeTributario
    //             ).filter(f => f.chave != null)
    //             .map(m => dataRegimeTributario?.find(f => f.codigo == m.chave))
    //             .filter(f => f != null)
    //         ;
    
    //         formulario.setFieldsValue({
    //             isAlteracao : isAlteracao,
    //             servico : {
    //                 ...servicoSalvo
    //             }
    //         });
    //     }
    // }, [isSuccess, servicoSalvo, dataRegimeTributario]);



    return <Spin spinning={isAlteracao && isPedingBuscarServico || isPending} delay={0}>
        <Form<FormType>
            layout="vertical"
            autoComplete="off"
            onFinish={(data) => {
                if (isAlteracao)
                    data.codPessoa = codPessoa;
                mutate(data);
            }}
            form={formulario}
        >
            <Row gutter={8} wrap>
                <Divider orientation="left">Recibo Provisório de Serviços</Divider>
                <Col xs={24} sm={12} md={8} lg={5} xl={4} xxl={3}>
                    <Form.Item<FormType> name={"ultimoNumeroRps"} label={"Último número"} rules={[
                        {
                            required : true
                        }
                    ]}>
                        <InputNumber style={{ width : "100%" }}  placeholder="Número última Rps" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={5} xl={4} xxl={3}>
                    <Form.Item<FormType> name={"serieRps"} label={"Série"} rules={[
                        {
                            required : true
                        }
                    ]}>
                        <InputNumber style={{ width : "100%" }}  placeholder="Série rps" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
                    <Form.Item<FormType> name={"regimeTributario"} label="Regime tributário" rules={[
                        {
                            required : true
                        }
                    ]}>
                        <RegimeTributarioSelect
                            onDeselect={(value) => {
                                formulario.setFieldValue(
                                    ["servico","valoresImpostos"],
                                    (formulario.getFieldValue(["servico","valoresImpostos"]) as ValorServico[] ?? [])
                                    .filter(f => f.valor?.codRegimeTributario != value)
                                );
                            }}
                            onClear={() => {
                                formulario.setFieldValue(["servico","valoresImpostos"], []);
                            }}
                        /> 
                    </Form.Item>
                </Col>
                {(regimeTributario?.codigo ?? 0) > 0 && 
                    <Col xs={24}>
                        <Form.Item<FormType> name={["valoresImpostos"]}>
                            <ValorServicoFormBasic
                                codGrupoTributario={EnumGrupoTributario.Empresa}
                                codRegimeTributario={regimeTributario.codigo}
                                nomeRegimeTributario={regimeTributario.nome}
                            />
                        </Form.Item>
                    </Col>
                }
            </Row>
            <Flex gap="small" wrap="wrap" justify="center">
                {!!buttoCencelar && buttoCencelar}
                {
                    !!!buttoCencelar && !!onCancelar && <Button type='primary' danger htmlType='reset' onClick={onCancelar}>
                        Cancelar
                    </Button>
                }
                <Button type='primary' htmlType='submit' loading={isPending}>
                    Salvar
                </Button>
            </Flex>
        </Form>
    </Spin>;
}

